import React,{useState,useEffect} from 'react';
import {Modal,Icon,Select,Button,TreeSelect } from 'antd';
import {filterUniversityName,getCookie, setCookie} from './service/common.js';
import {messageTips} from './service/Tools.jsx';
const { Option } = Select;

let timeout;

function fetch(value, callback) {
	if (timeout) {
		clearTimeout(timeout);
		timeout = null;
	}

	function fake() {
	React.$http.getPersoanlUserGetGroup({groupName:value})
		.then(res => {
			if(res.list) {
				callback(res.list)
			}
		});
	}
	timeout = setTimeout(fake, 300);
}

function Perfection() {
    
    const [isModalVisible, setisModalVisible] = useState(false);
    const [currentStep, setcurrentStep] = useState(1);
    const [ipOrg, setipOrg] = useState({});
    const [ip, setip] = useState('');
    const [orgName, setorgName] = useState([]);
    const [universityName, setuniversityName] = useState('');
    const [selectedUniersityId, setselectedUniersityId] = useState('');
    const [universities, setuniversities] = useState([]);
    const [college, setcollege] = useState('');
    const [colleges, setcolleges] = useState([]);
    const [validTime, setvalidTime] = useState(0);
    const [ipColleges, setipColleges] = useState([]);


    useEffect(() => {
        let noAlertPerfection = getCookie('noAlertPerfection');
        if(!noAlertPerfection) {
            let sid = getCookie('z_sid');
            if(sid) {

                React.$http.getUserInfo({type:1}).then(res=>{
                    if(res) {
                        if(res.success&&(res.userInfo.groupId===null||res.userInfo.groupId===undefined||res.userInfo.groupId===-1)) {
                            setisModalVisible(true);
                            setvalidTime(res.time);
                            if(res.groupCode&&res.roleType) {	
                                setcurrentStep(2);	
                                
                                setuniversityName(res.groupCode);
                                setselectedUniersityId(res.groupCode);
                                setcollege(res.collegeId);
                                getColleges(res.groupCode);
                            }
                            return res;
                        } else {
                            return false;
                        }
                    }else {
                        return false;
                    }
                }).then(res=>{
                    if(res) {
                        React.$http.getIP().then(resp=>{
                            if(resp&&resp.success) {
                                let arr = [];
                                if(resp.groupName) {
                                    arr.push(resp.groupName);                        
                                }
                                if(resp.collegeName) {
                                    arr.push(resp.collegeName);
                                }
                                setorgName(arr);
                                setip(resp.ip);
                                setuniversities([
                                    {
                                        groupCode: resp.groupCode,
                                        groupId: res.groupId,
                                        groupName: res.groupName
                                    }
                                ]);	
                                let ipOrg = {
                                    collegeCode: resp.collegeCode,
                                    collegeName: resp.collegeName,
                                    groupCode: resp.groupCode,
                                    groupName: resp.groupName,
                                    collegeId:resp.collegeId,
                                    grouplist:resp.ipGroupList
                                }
                                let arrs = resp.ipGroupList.map(item=>item.collegeId);
                                setipColleges(arrs);
                                setipOrg(ipOrg);
                            }
                        });
                    }
                })		
            } 
        }
        
        return () => {
            
        };
    }, []);



    const setClassName = (num)=>{
        let className = 'line line'+num;
        if(currentStep===num) {
            className+=' active';
        }
        if(currentStep>num) {
            className+=' passed';
        }
        return className;
    }
    const setClassName2 = (num)=>{
        let className = 'step step'+num;
        if(currentStep===num) {
            className+=' active';
        }
        if(currentStep>num) {
            className+=' passed';
        }
        return className;
    }
    const applyCurrentOrg=()=>{
        setuniversityName(ipOrg.groupName);
        setselectedUniersityId(ipOrg.groupCode);
        setTimeout(()=>{setcollege(ipOrg.collegeId);},500);
        getColleges(ipOrg.groupCode);
    }


    const handleSearchUniversity=(value) => {
        if(value.length<2||filterUniversityName.indexOf(value)!==-1) {
            return false;
        }
        fetch(value, data => (setuniversities(data)));
    }
    const handleChangeUniversity=(value) => {
        setuniversityName(value);	
        setselectedUniersityId(value);	
        getColleges(value);	
        setcollege('');				
    }

    const getColleges=(id)=>{
        React.$http.getOrgList({type:1,groupCode:id?id:selectedUniersityId,isPerfect:1}).then(res=>{
            if(res) {
                if(res.groupList) {
                    let result = setTree(res.groupList);
                    setcolleges(result);
                }
            }
        });
    }

    const setTree = (arr)=>{        
        arr.forEach((item)=>{
            item.title = item.groupName;
            item.value = item.groupId;
            item.key = item.groupId;
            item.children = item.childList?item.childList:[];
            if(item.children&&item.children.length>0) {
                setTree(item.children);
            }
        });
        return arr;
    }

    const goNextStep=()=>{
        if(!universityName) {
            messageTips('请选择机构',2);
            return false;
        }
        if(!college) {
            messageTips('请选择学院',2);
            return false;
        }
        return true;
    }


    const submit=()=>{
        if(!goNextStep()) {
            return false;
        }
        let params = {
            collegeId:college,
            roleType:0,
            ipGroup:ipColleges.indexOf(college)!==-1?1:0
        }
        
        React.$http.perfectInfo(params).then(res=>{
            if(res) {
                if(res.success) {
                    messageTips(res.message,3);
                    setisModalVisible(false);
                } else {
                    messageTips(res.message,1);
                }
            }
        })            
    }

    const hideModal=()=>{
        setisModalVisible(false);
        setCookie('noAlertPerfection',1,1);
    }

    const changeCurrenCollege=(e)=>{
        let _ipOrg = {...ipOrg};
        _ipOrg.collegeId = e;
        setipOrg(_ipOrg);
    }

    return (
        <Modal
          title="完善信息"
          visible={isModalVisible}
          footer={null}
          centered={true}
          width={618}
          onCancel={hideModal}
          wrapClassName="perfection"
          maskClosable={false}
        >
            <div className="perfection-content">
                <div className="steps">
                    <div className={setClassName(0)}></div>
                    <div className="step-wrap">
                        <div className={setClassName2(1)}>
                            <div className="icon-bg">
                                <Icon type="bank" />
                            </div>
                            <div className="name">选择机构</div>
                        </div>
                    </div>
                </div>


                <div className="step-1" style={{display:currentStep===1?'block':'none'}}>
                    <div className="p">您当前IP为：{ip}，机构为：
                    {
                        ipOrg.groupCode?<span> <span>{ipOrg.groupName} - </span>
                        <Select value={ipOrg.collegeId} onChange={changeCurrenCollege}>
                            {
                                ipOrg.grouplist?ipOrg.grouplist.map((item,key)=>{
                                    return <Option key={key} value={item.collegeId}>{item.collegeName}</Option>
                                }):''
                            }
                        </Select>
                        </span>:''
                    } 
                        <span className="link" style={{display:ipOrg.groupCode?'inline':'none'}} onClick={applyCurrentOrg}>应用当前机构</span>
                    </div>
                    <div className="form-item">
						<div className="label">
							选择机构
						</div>
						<div className="input-wrap">
                        <Select
                            showSearch
                            value={universityName}
                            placeholder=""
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            onSearch={handleSearchUniversity}
                            onChange={(e)=>{handleChangeUniversity(e)}}
                            notFoundContent={null}
                            style={{width:250}}
                            showArrow={false}
                            
                        >
                            {
                                universities.map((item,key)=>{
                                    return <Option key={key} value={item.groupCode}>{item.groupName}</Option>
                                })
                            }
                        </Select>
                        <Icon type="search" />
						</div>
					</div>

					<div className="form-item">
						<div className="label">
							所在学院
						</div>
						<div className="input-wrap">
                            <TreeSelect
                                value={college}
                                placeholder="选择"
                                defaultActiveFirstOption={false}
                                filterOption={false}
                                notFoundContent={null}
                                style={{width:250}}
                                onChange={(e)=>{setcollege(e)}}
                                showArrow={false}
                                treeData={colleges}
                                dropdownClassName="select-college"
                            >
                            </TreeSelect>
                            <Icon type="apartment" />
						</div>
					</div>
                    
                    {
                        validTime>0?<div className="primary">*以上是您此前填写的机构信息，您的机构认证将于{validTime}天后失效</div>:''
                    }
                    
                    {
                        ipColleges.indexOf(college)!==-1?'':<div className="error">*您选择的机构与当前IP不匹配，请尽快在相应IP下完成认证</div>
                    }
					

					<div className="form-item">
						<div className="btns">
                        <Button type="primary" ghost onClick={hideModal}>取消</Button>
                        <Button type="primary" onClick={submit}>确定</Button>
						</div>
					</div>
                </div>
            </div>
        </Modal>
    );
}

export default Perfection;